module.exports = __webpack_public_path__ + "141d4a85/img/copy-icon.408fdb2d.svg";